<script setup lang="ts">
  import { getCurrentInstance, onMounted, ref } from "vue";
  import { useMainStore } from "~/stores";
  import Logger from "~/utils/logger";
  import { CloseCircleOutlined } from "@ant-design/icons-vue";

  const props = withDefaults(
    defineProps<{
      urlType: string;
    }>(),
    {
      urlType: "",
    },
  );

  const emit = defineEmits(["open", "close"]);

  const instance = getCurrentInstance()?.proxy as any;
  const store = useMainStore();
  const bannerList = ref<any[]>([]);
  const isShow = ref(false);

  const loadData = () => {
    const params = { platform: props.urlType, position: "home", versionType: store.versionType };
    instance.$Request.get("/api/v1/promotion/queryPlatformBanners", params).then((res: any) => {
      bannerList.value = res;
      if (res && res.length > 0) {
        emit("open");
        isShow.value = true;
      }
    });
  };
  const logger = (item: any) => {
    const PROGRAM_NAME = props.urlType;
    const BANNER_TITLE = item.title;
    Logger.event("banner推广_点击次数", {
      banner标题: BANNER_TITLE,
      项目platform: PROGRAM_NAME,
    });
    if (BANNER_TITLE === "律师入驻") Logger.event("法搜首页_点击广告_立即入驻");
  };
  const cancel = () => {
    const params = { platform: props.urlType, position: "home", close: true, versionType: store.versionType };
    instance.$Request.get("/api/v1/promotion/queryPlatformBanners", params).then(() => {
      isShow.value = false;
      emit("close");
    });
  };

  onMounted(() => {
    loadData();
  });
</script>

<template>
  <div v-if="isShow" class="banner-box" :class="{ 'banner-box-show': isShow }">
    <div class="cancel" @click="cancel()">
      <CloseCircleOutlined style="font-size: 20px; color: #fff" />
    </div>
    <a-carousel autoplay>
      <div v-for="(item, index) in bannerList" :key="index">
        <div @click="logger(item)">
          <a :href="item.linkUrl" class="banner-item">
            <img :src="item.banner" />
          </a>
        </div>
      </div>
    </a-carousel>
  </div>
</template>

<style lang="less" scoped>
  .banner-box {
    position: relative;
    z-index: 99;
    width: 100%;
    height: 4rem;
    overflow: hidden;
    visibility: hidden;
    opacity: 0;
    transition: ease 300ms all;

    &.banner-box-show {
      visibility: visible;
      opacity: 1;
    }

    :deep(.ant-carousel) {
      .slick-track {
        height: 64px !important;
      }
    }

    img {
      width: 100%;
      height: 4rem;
      object-fit: cover;
    }
  }

  :deep(.ant-carousel) {
    .slick-dots {
      position: absolute;
      bottom: 25px !important;
      display: block !important;
      width: 100%;
      height: 3px;
      text-align: center;
      transform: translateX(600px);

      li {
        width: 14px !important;

        button {
          width: 14px !important;
          height: 14px !important;
          margin-right: 16px;
          background: rgba(255, 255, 255, 60%);
          border-radius: 50%;
          opacity: 1;
        }
      }
    }

    .slick-slider .slick-dots .slick-active button {
      background: #fff;
    }
  }

  .cancel {
    position: absolute;
    top: 50%;
    right: 72px;
    z-index: 66;
    cursor: pointer;
    transform: translateY(-50%);
  }
</style>
